module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signup-type border-bottom-light row justify-content-sm-center"
  }, [(_vm.types) ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("I am...")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.types,
      "label": "description"
    },
    on: {
      "input": _vm.updateType
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-657f0933", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-657f0933"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/SignupType.vue
// module id = 2638
// module chunks = 0